import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export interface XlsxColumnDef {
    header: string;
    key: string;
    width?: number;
}

export interface ExportXlsxParams {
    sheetName: string;
    fileName: string;
    columns: XlsxColumnDef[];
    rows: any[];
    fontSize?: number;
}

export const exportXlsxWithFontSize = async ({
    sheetName,
    fileName,
    columns,
    rows,
    fontSize = 8,
}: ExportXlsxParams) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    worksheet.columns = columns;

    worksheet.addRows(rows);

    worksheet.eachRow((row, rowNumber) => {
        row.eachCell({ includeEmpty: true }, (cell) => {
            cell.font = { name: 'Calibri', size: fontSize };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

            if (rowNumber === 1) {
                cell.font = { name: 'Calibri', size: fontSize + 1, bold: true };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(blob, fileName);
};